import { WEDDING_TYPE } from '@/constants'
import { ErrorCode } from '@/errors/errorCode'
import { format } from 'date-fns'

export const formatWeddingDate = (date?: string, dateType?: string) => {
  if (!date) {
    return ''
  }

  try {
    if (!dateType) {
      return format(date, 'dd/MM/yyyy')
    }

    switch (dateType) {
      case WEDDING_TYPE.DATE:
        return format(date, 'dd/MM/yyyy')
      case WEDDING_TYPE.YEAR_MONTH:
        return format(date, 'MMMM yyyy')
      case WEDDING_TYPE.YEAR_SEASON:
        // season should be omitted
        return ''
      default:
        return format(date, 'dd/MM/yyyy')
    }
  } catch (error) {
    console.error(ErrorCode.e00150, error)
    return ''
  }
}
